import React from 'react';
import '../scripts/responsiveslides.js-v1.53/responsiveslides.css';
import '../styles/main.css';
import '../styles/RightSideMenu.css';
import './DashBoard.css'
import { Link } from 'react-router-dom';
import audit from '../images/audit.png';
import new_gif from '../images/neww.gif'
import '../ticker/css/jquerysctipttop.css';
import ImageSlider from './ImagesSlider';
import AwardsScroller from "./awardsScroller/AwardsScroller";


const Home = () => {

  return (
    <>
      <div className="wrapper">
        <div className="wrapper row3">
          <div id="container">

            {/* LEFT SIDEBAR */}
            {/* <div id="sidebar_1" className="sidebar one_quarter first">
              <section>
                <Link to="/Month_Trans_Interface" title="Month Abstract">
                  <img alt="" style={{ width: '100%', height: 'auto' }} src={audit} />
                </Link>
              </section>
            </div> */}

            {/* CENTER - IMAGE SLIDER */}
            <div className="" style={{backgroundColor:"white", width:"100%", height: '50vh'}}>
              <section className="" style={{  }}>
                <div className="rslides_container clear">
                  <ImageSlider />
                </div>
              </section>
            </div>

            {/* RIGHT SIDEBAR */}
            {/* <div id="sidebar_2" className="sidebar one_quarter">
              <aside className="clear">
                <section className="clear">
                  <div style={{ marginRight: '10px' }}>
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <img src={new_gif} style={{ float: 'left' }} alt="" /> &nbsp;
                        <marquee scrolldelay="150">
                          <span className="style1">
                            Distribution is in progress.
                          </span>
                        </marquee>
                      </div>
                    </div>
                  </div>
                </section>
              </aside>
            </div> */}

            <div className="clear"></div>
            <AwardsScroller />


          </div>
        </div>
      </div>
    </>
  );
};

export default Home;